import React from 'react';
import styles from '../UserDropdown.module.scss';
import Div from '../../Element/Div/Div';
import Flex from '../../Flex/Flex';
import Icon from '../../Icon/Icon';
import Gutter from '../../Gutter/Gutter';
import BodyText from '../../Typography/BodyText/BodyText';
import { CommonProps } from '../../Element/Element';

export type UserDropdownAccountProps = {
  /** String for name */
  name?: string;
  /** String for username */
  username?: string;
  /** Addition content shown below username */
  children?: any;
} & CommonProps<'div'>;

const UserDropdownAccount: React.FunctionComponent<UserDropdownAccountProps> = ({
  name,
  username,
  children,
  ...props
}) => {
  return (
    <Div
      padding={{ size: 'md' }}
      className={styles.userDropdown__borderBottom}
      {...props}
    >
      <Flex centeredVertically>
        <Icon
          name="pebble"
          size="md"
          color="purple500"
          margin={{ bottom: 'sm' }}
        />

        <Gutter />

        <Div>
          {name && (
            <BodyText
              tagName="span"
              block
              fontWeight="medium"
              className="name-test"
              color="black"
            >
              {name}
            </BodyText>
          )}

          {username && (
            <BodyText
              tagName="span"
              size="xs"
              className={[styles.userDropdown_items__nowrap, 'username-test']}
            >
              {username}
            </BodyText>
          )}

          {children && (
            <>
              <Gutter size="xs" />

              <Div>{children}</Div>
            </>
          )}
        </Div>
      </Flex>
    </Div>
  );
};

export default UserDropdownAccount;
